import React from 'react';
import Panel from '../../styled/Panel';

import { IItemBase, IItemPanel, ItemId } from './types';
import ItemPanelContent from './ItemPanelContent';

const ItemPanel = <TItemId extends ItemId, TItem extends IItemBase<TItemId>>({
  selectedId,
  items: allItems,
  featuredItems,
  featuredItemsLabels,
  onClose,
  onSelect,
  renderStatus,
  selectableQuery,
  retainOnClose,
  searchLabel,
  selectedOnTop,
  title,
  multipleActions,
  onSearch,
  noMatchText,
  loading,
  switchOptions,
}: IItemPanel<TItemId, TItem>) => {
  return (
    <Panel title={title} onClose={onClose}>
      <ItemPanelContent
        onClose={onClose}
        onSelect={onSelect}
        retainOnClose={retainOnClose}
        switchOptions={switchOptions}
        items={allItems}
        featuredItems={featuredItems}
        featuredItemsLabels={featuredItemsLabels}
        selectedOnTop={selectedOnTop}
        selectedId={selectedId}
        onSearch={onSearch}
        searchLabel={searchLabel}
        loading={loading}
        renderStatus={renderStatus}
        multipleActions={multipleActions}
        selectableQuery={selectableQuery}
        noMatchText={noMatchText}
      />
    </Panel>
  );
};

export default ItemPanel;
